export default __webpack_public_path__ + "media/images/icons/psd-818043d7cff6ca54ddf6f01524edfa71.png";